import { getTerminalErrorPresentation } from '../utils/terminalErrorPresentation';

type TerminalErrorNoticeProps = {
  error: string;
  onDismiss?: () => void;
};

export function TerminalErrorNotice({ error, onDismiss }: TerminalErrorNoticeProps) {
  const presentation = getTerminalErrorPresentation(error);

  return (
    <div className="rounded-md border border-destructive/30 bg-destructive/10 p-3 text-sm text-destructive">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="font-medium">{presentation.title}</div>
          <div className="mt-1 text-destructive/90">{presentation.message}</div>
        </div>
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="rounded px-2 py-1 text-xs text-destructive/80 hover:bg-destructive/10 hover:text-destructive"
          >
            Dismiss
          </button>
        )}
      </div>

      <details className="mt-2">
        <summary className="cursor-pointer select-none text-xs text-destructive/80 hover:text-destructive">
          Error details
        </summary>
        <pre className="mt-2 whitespace-pre-wrap break-words rounded bg-destructive/5 p-2 font-mono text-[11px] leading-relaxed text-destructive/80">
          {presentation.details}
        </pre>
      </details>
    </div>
  );
}

